import React, {useMemo} from 'react';
import {Navigate, useParams} from "react-router-dom";
import {useOpportunity} from "../../../providers/OpportunityProvider";
import Team from "../../../models/Team";
import TeamCandidateScopeProvider from "../../client-lead-tools/team-scope/TeamCandidateScopeProvider";
import ManageTeamScopeTable from "../../client-lead-tools/team-scope/ManageTeamScopeTable";

const SupplierManageTeamScopeLayout = () => {
    const {
        opportunity,
        isDisabled
    } = useOpportunity();

    const {candidateId} = useParams();

    const matchedTeam = useMemo(() => {
        if (!candidateId) {
            return null
        }
        let teamOpp = TB.find(opportunity.matching_talent, ['job_candidate.id', parseInt(candidateId)]);
        if (!teamOpp) {
            return teamOpp;
        }
        let candidate = {...teamOpp, ...teamOpp.team};
        delete candidate.team;
        delete candidate.project;
        candidate.disciplines = [...(opportunity.project.disciplines || [])]
        return Team.make(candidate);
    }, [opportunity, candidateId]);

    if (matchedTeam && matchedTeam?.is_dead) {
        return <Navigate to={"./.."} replace={true}/>
    }
    return (
        <div className="flex-grow container-fluid flex flex-col items-stretch">
            <div className="px-2 flex flex-col bidding-brief-step">
                <div className="flex flex-col items-stretch gap-10 px-8 py-10 relative">
                    <TeamCandidateScopeProvider
                        opportunityId={opportunity.id}
                        team={matchedTeam} project={opportunity.project}
                        isDisabled={isDisabled}
                    >
                        <ManageTeamScopeTable forAgency={true}/>
                    </TeamCandidateScopeProvider>
                </div>
            </div>
        </div>
    );
};

export default SupplierManageTeamScopeLayout;